import { DeclarationMouvementEdition } from './declaration-mouvement-edition.model';
import { DeclarationSiteEdition } from './declaration-site-edition.model';
import { DeclarationOperateurEdition } from './declaration-operateur-edition.model';
import { OrganismeEdition } from './organisme-edition.model';
import { DeclarationLotsLabellises } from './declaration-lots-labellises.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationEdition {
    static jsonMap = {
        numeroDossier: { key: 'numeroDossier', optional: true, default: '' },
        date: { key: 'date', optional: true, default: '' },
        cahier: { key: 'cahier', optional: true, default: '' },
        typeRevendication: { key: 'typeRevendication', optional: true, default: '' },
        auteurDeclaration: { key: 'auteurDeclaration', optional: true, default: '' },
        dateValidation: { key: 'dateValidation', optional: true, default: '' },
        lots: {
            key: 'lots',
            converter: new (ArrayClassConverterFactory.build(DeclarationMouvementEdition))(),
            optional: true
        },
        lotsNonControlables: {
            key: 'lotsNonControlables',
            converter: new (ArrayClassConverterFactory.build(DeclarationMouvementEdition))(),
            optional: true
        },
        lotsControlables: {
            key: 'lotsControlables',
            converter: new (ArrayClassConverterFactory.build(DeclarationMouvementEdition))(),
            optional: true
        },
        lotsLabellises: {
            key: 'lotsLabellises',
            converter: new (ArrayClassConverterFactory.build(DeclarationLotsLabellises))(),
            optional: true
        },
        site: { key: 'site', converter: new (ClassConverterFactory.build(DeclarationSiteEdition))(), optional: true },
        operateur: { key: 'operateur', converter: new (ClassConverterFactory.build(DeclarationOperateurEdition))(), optional: true },
        organisme: { key: 'organisme', converter: new (ClassConverterFactory.build(OrganismeEdition))(), optional: true },
        nbLotsLabel: { key: 'nbLotsLabel', optional: true },
        volumeLabel: { key: 'volumeLabel', optional: true }
    };

    numeroDossier: string;
    date: string;
    cahier: string;
    typeRevendication: string;
    auteurDeclaration: string;
    dateValidation: string;
    lots: DeclarationMouvementEdition[];
    lotsNonControlables: DeclarationMouvementEdition[];
    lotsControlables: DeclarationMouvementEdition[];
    lotsLabellises: DeclarationLotsLabellises[];
    site: DeclarationSiteEdition;
    operateur: DeclarationOperateurEdition;
    organisme: OrganismeEdition;
    nbLotsLabel: number;
    volumeLabel: number;

    // Données non mappées
    email: string;
}
